import { Commit, Module, Plugin } from 'vuex';
import axios, { AxiosResponse } from 'axios';
import withConfig from "@growmark/axios/core";
import { bearer } from "@growmark/axios/config";
import { cognito } from "@growmark/axios/authn/cognito";
import instance, { login } from "@growmark/cognito-vue";
import { MySolutionCenterCompanyInfo } from '@/utils/types';

const api = withConfig([
  bearer(cognito(instance), { header: "Authorization" }),
])(
  axios.create({
    baseURL: process.env.VUE_APP_SOLUTION_CENTER_API,
    timeout: 30000,
  })
);

const cognitoAPI = withConfig([
  bearer(cognito(instance), { header: "Authorization" }),
])(
  axios.create({
    baseURL: `https://${process.env.COGNITO_DOMAIN}`,
    timeout: 30000,
  })
);

const state = {
  signInStatus: false,
  mySolutionCenters: [] as MySolutionCenterCompanyInfo[],
  preferedTheme: window?.matchMedia('(prefers-color-scheme: dark)')?.matches || false,
};

const getters = {
  getSignInStatus(state: State) {
    return state.signInStatus;
  },
  getMySolutionCenterLinks(state: State) {
    return state.mySolutionCenters.map((CompanyInfo: MySolutionCenterCompanyInfo) => CompanyInfo.AgvanceCompanyID);
  },
};

const mutations = {
  SET_SIGNED_IN_STATUS(state: State, payload: boolean) {
    state.signInStatus = payload;
  },
  SET_MY_SOLUTION_CENTER_INFO(state: State, payload: MySolutionCenterCompanyInfo[]) { 
    state.mySolutionCenters = payload;
  },
};

const actions = {
  async signIn() {
    await login(instance);
  },
  async signOut(context: { commit: Commit}) {
    await instance.signOut();
  },
  async fetchSolutionCenterLinks(context: { commit: Commit, state: State }) {
    try {
      const session = await instance.currentSession();
      const token = session.getIdToken().decodePayload();
      if (!token) return;
      const custom_affiliations: string = token['custom:affiliations'].replace(/[[\]"]/gi, '');
      
      const response: AxiosResponse = await api.get({
        url: '/pull/getsqlservercompaniesformyfshub',
        query: {
          SAPKunnrs: custom_affiliations
        }
      });
      
      const MySolutionCenterInfo: MySolutionCenterCompanyInfo[] = response.data;
      context.commit('SET_MY_SOLUTION_CENTER_INFO', MySolutionCenterInfo);
    } catch (___) {___}
  },
  async fetchSignedInStatus(context: { commit: Commit, state: State }) {
    let isSignedIn = false;
    if (!instance) return;
    try {
      const session = await instance.currentSession();
      isSignedIn = session.isValid();
    } catch (___) {___} 
    context.commit('SET_SIGNED_IN_STATUS', isSignedIn);
  },
};

//types
type MinimalRootState = {/* minimum needed for typesafety */};
export type State = typeof state;
export type Actions = typeof actions;
export type Getters = typeof getters;
export type Mutations = typeof mutations;

//js exports
export const NAMESPACE = 'main';
export const plugin: Plugin<State> = async store => {
  //things to setup state initially or listen for other namespaced mutations
  store.subscribe(mutation => {
    switch(mutation.type){
      default: return; //do something based on mutation (e.g. save state into storage... etc.)
    }
  });
};
export const module: Module<State, MinimalRootState> = {
  namespaced: true,
  state, getters, actions, mutations
};